import { Badge } from '@/components/ui/badge';
import type { HomeEvalJobStatus, TaskGenerationJobRunStatus } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const JobStatusBadge: FC<{
    status: HomeEvalJobStatus | TaskGenerationJobRunStatus | undefined;
}> = ({ status }) => {
    if (!status) {
        return <Badge variant="outline">Unknown</Badge>;
    }

    switch (status) {
        case 'pending':
            return <Badge variant="secondary">Pending</Badge>;
        case 'running':
            return <Badge variant="default">Running</Badge>;
        case 'success':
            return <Badge className="bg-green-600">Success</Badge>;
        case 'error':
            return <Badge variant="destructive">Error</Badge>;
        default:
            assertUnreachable(status);
    }
};
